"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentLoadedMetrics = void 0;
const KatalMetrics = __importStar(require("@amzn/katal-metrics"));
const toString_1 = __importDefault(require("lodash/toString"));
const react_1 = require("react");
const taaConfigs_1 = require("../../../contexts/taaConfigs");
const logger_1 = require("../../../logger");
const useComponentLoadedMetrics = ({ metricNames, isComponentLoaded, isFirstRenderState }) => {
    var _a;
    const { clientName, associateInfo } = (0, taaConfigs_1.useTaaConfigsContext)();
    const metricTimer = (0, react_1.useRef)(new KatalMetrics.Metric.TimerStopwatch(logger_1.METRICS.PUNCH_FEATURE.LATENCY).withMonitor());
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB,
        countryCode: (_a = associateInfo === null || associateInfo === void 0 ? void 0 : associateInfo.countryCode) !== null && _a !== void 0 ? _a : 'N/A'
    };
    if (!!isFirstRenderState) {
        dimensions.isFirstRender = (0, toString_1.default)(isFirstRenderState.isFirstRender);
    }
    (0, react_1.useEffect)(() => {
        if (isComponentLoaded) {
            if (!!metricNames.latencyMetricName) {
                logger_1.logger.emitLatencyMetric({
                    metricName: metricNames.latencyMetricName,
                    metricValue: metricTimer.current.value,
                    dimensions
                });
            }
            if (!!metricNames.countMetricName) {
                logger_1.logger.emitCountMetric({
                    metricName: metricNames.countMetricName,
                    dimensions
                });
            }
            if (!!(isFirstRenderState === null || isFirstRenderState === void 0 ? void 0 : isFirstRenderState.isFirstRender)) {
                isFirstRenderState.setIsFirstRender(false);
            }
        }
    }, [isComponentLoaded]);
};
exports.useComponentLoadedMetrics = useComponentLoadedMetrics;
